import createIcon from '../../createIcon';

/**
 * @component @name SportsMma
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAyMEM3IDIwLjU1IDcuNDUgMjEgOCAyMUgxNkMxNi41NSAyMSAxNyAyMC41NSAxNyAyMFYxN0g3VjIwWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4IDdDMTcuNDUgNyAxNyA3LjQ1IDE3IDhWNUMxNyAzLjkgMTYuMSAzIDE1IDNIN0M1LjkgMyA1IDMuOSA1IDVWMTAuOEM1IDEwLjkzIDUuMDEgMTEuMDYgNS4wNCAxMS4xOUw1Ljg0IDE1LjE5QzUuOTMgMTUuNjYgNi4zNCAxNS45OSA2LjgyIDE1Ljk5SDE3LjE4QzE3LjYzIDE1Ljk5IDE4LjA3IDE1LjYzIDE4LjE2IDE1LjE5TDE4Ljk2IDExLjE5QzE4Ljk5IDExLjA2IDE5IDEwLjkzIDE5IDEwLjhWOEMxOSA3LjQ1IDE4LjU1IDcgMTggN1pNMTUgMTBIN1Y3SDE1VjEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsMma = createIcon('SportsMma', [
  ['path', { d: 'M7 20C7 20.55 7.45 21 8 21H16C16.55 21 17 20.55 17 20V17H7V20Z', key: '127suw' }],
  [
    'path',
    {
      d: 'M18 7C17.45 7 17 7.45 17 8V5C17 3.9 16.1 3 15 3H7C5.9 3 5 3.9 5 5V10.8C5 10.93 5.01 11.06 5.04 11.19L5.84 15.19C5.93 15.66 6.34 15.99 6.82 15.99H17.18C17.63 15.99 18.07 15.63 18.16 15.19L18.96 11.19C18.99 11.06 19 10.93 19 10.8V8C19 7.45 18.55 7 18 7ZM15 10H7V7H15V10Z',
      key: 'byar4v',
    },
  ],
]);

export default SportsMma;
